import React from 'react';

type SampleCountStatsProps = {
    nSamples: number;
    n95: number;
    confidence: number;
};

// Progress bars for sample count and confidence
export const SampleCountStats: React.FC<SampleCountStatsProps> = (
    {nSamples, n95, confidence}
) => {
    return (
     <div style={{ margin: '5px 0', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
        <div style={{ marginBottom: '5px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Échantillons collectés</span>
            <span style={{ fontSize: '14px', color: '#666' }}>
            {nSamples} / {n95}
            </span>
        </div>
        <div style={{ 
            width: '100%', 
            height: '20px', 
            backgroundColor: '#e0e0e0', 
            borderRadius: '10px',
            overflow: 'hidden'
        }}>
            <div style={{ 
            width: `${Math.min((nSamples  / n95) * 100, 100)}%`,
            height: '100%',
            backgroundColor: nSamples >= n95 ? '#4caf50' : '#2196f3',
            transition: 'width 0.3s ease',
            borderRadius: '10px'
            }} />
        </div>
        </div>

        <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Niveau de confiance</span>
            <span style={{ fontSize: '14px', color: '#666' }}>
            {confidence?.toFixed(1) || 0}%
            </span>
        </div>
        <div style={{ 
            width: '100%', 
            height: '20px', 
            backgroundColor: '#e0e0e0', 
            borderRadius: '10px',
            overflow: 'hidden'
        }}>
            <div style={{ 
            width: `${confidence || 0}%`,
            height: '100%',
            backgroundColor: (confidence || 0) >= 95 ? '#4caf50' : 
                            (confidence || 0) >= 90 ? '#ff9800' : '#f44336',
            transition: 'width 0.3s ease',
            borderRadius: '10px'
            }} />
        </div>
        </div>
     </div>
    );
};